import React, { useEffect, useState } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";
import { Eye } from "lucide-react";
import DetailsView from "./DetailsView";
import Loader from "../../../../Utils/Loader";
import "react-datepicker/dist/react-datepicker.css";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable1";

import { fDateTimeSuffix } from "../../../../Utils/Date_formet";
import { getcloseposition, SubadminClosePosition } from "../../../../Service/admin.service";
import { SET_THEME_DETAILS } from "../../../../Service/auth.service";
import { Get_All_Strategy } from "../../../../ReduxStore/Slice/Admin/StrategySlice";
import { getAllStrategyName } from "../../../../Service/admin.service";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

const Tradinghistory = () => {

  const gotodashboard = JSON.parse(localStorage.getItem("user_details_goTo"));
  const isgotodashboard = JSON.parse(localStorage.getItem("gotodashboard"))

  const user_details = JSON.parse(localStorage.getItem("user_details"));


const today = format(new Date(), "yyyy-MM-dd");

const [fromDate, setFromDate] = useState(today);
const [toDate, setToDate] = useState(today);

  const [showModal, setshowModal] = useState(false);
  const [rowData, setRowData] = useState("");
  const [tradeHistoryData, setTradeHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPnl, setTotalPnl] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [btnstatus, setBtnstatus] = useState([]);
  const [quantity, setQuantity] = useState("1");
  const [ForGetCSV, setForGetCSV] = useState([]);
  const [startegydata, setStrategydata] = useState([]);
  const [strategy, setStrategy] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUsername, setSelectedUsername] = useState("");


  const roundSmart = (value) => {
    if (isNaN(value)) return null;
    value = Number(value);

    let digits;
    if (Math.abs(value) >= 1000) {
      digits = 2;
    } else if (Math.abs(value) >= 1) {
      digits = 2;
    } else if (Math.abs(value) >= 0.01) {
      digits = 4;
    } else {
      digits = 6;
    }

    return Number(value.toFixed(digits));
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newLimit, page) => {
    setLimit(newLimit);
    setCurrentPage(1);
  };

  useEffect(() => {
    getCompanydata();
    getStartegy();
  }, []);

  const refreshbtn = () => {
    setStrategy("");
  };

  const getCompanydata = async () => {
    try {
      const res = await SET_THEME_DETAILS();
      if (res.status) {
        setBtnstatus(res.data[0]?.pnl_position);
      }
    } catch (error) { }
  };

  const getStartegy = async () => {
    try {
      const res = await getAllStrategyName();
      if (res.status) {
        setStrategydata(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchTradeHistory = async () => {
    setLoading(true);
    try {
      const response = await SubadminClosePosition({
        page: currentPage,
        limit: limit,
        fromDate,
        toDate,
        Strategy: strategy,
        Symbol: "",
        userid: isgotodashboard ? gotodashboard.user_id : user_details.user_id
      });

      if (response?.status) {
        setTradeHistoryData(response.data || []);
        setTotalRows(response.pagination?.totalRecords || 0);

        setForGetCSV(
          (response.data || []).map((item, index) => ({
            "S.No": index + 1,
            "Signals Entry Time": item.createdAt,
            "Signals Exit Time": item.exitTime,
            Symbol: item.symbol,
            Strategy: item.strategy,
            "Entry Type": item.side,
            Quantity: item.quantity,
            "Entry Price": item.entryPrice,
            "Exit Price": item.exitPrice,
            "P/L": item.pnl,
            "User Name": item.userInfo?.UserName || "Admin",
          }))
        );

        let CalculatedTotalPnl = 0;
        response.data.forEach((item) => {
          if (item.pnl !== null) {
            const qty = quantity && quantity > 0 ? quantity : item.quantity;
            const profitLoss =
              item.side === "BUY"
                ? (item.exitPrice - item.entryPrice) * qty
                : (item.entryPrice - item.exitPrice) * qty;
            CalculatedTotalPnl += profitLoss;
          }
        });

        setTotalPnl(CalculatedTotalPnl);
      } else {
        setTradeHistoryData([]);
        setTotalRows(0);
        setTotalPnl(0);
      }
    } catch (err) {
      console.error("Error fetching trade history", err);
      setTradeHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredData = tradeHistoryData.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.symbol?.toLowerCase().includes(term) ||
      item.strategy?.toLowerCase().includes(term)
    );
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [fromDate, toDate]);

  useEffect(() => {
    fetchTradeHistory();
  }, [currentPage, fromDate, toDate, refresh, limit, strategy]);

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => (currentPage - 1) * limit + index + 1,
      sortable: false,
      width: "80px",
    },
    {
      name: "Signals Entry Time",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Signals Exit Time",
      selector: (row) => row.exitTime,
      cell: (row) => <>{row.exitTime ? fDateTimeSuffix(row.exitTime) : "-"}</>,
      sortable: true,
      width: "200px",
    },
    {
      name: "Symbol",
      selector: (row) => row.symbol,
      sortable: true,
      width: "120px",
    },
    {
      name: "Strategy",
      selector: (row) => row.strategy,
      sortable: true,
      width: "150px",
    },
    {
      name: "Entry Type",
      selector: (row) => row.side,
      cell: (row) =>
        row?.side === "BUY" ? (
          <span style={{ color: "green" }}>BUY ENTRY</span>
        ) : (
          <span style={{ color: "red" }}>SELL ENTRY</span>
        ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Quantity",
      selector: (row) =>
        quantity && quantity > 0 ? quantity : row.quantity || "-",
      sortable: true,
      width: "120px",
    },
    {
      name: "Entry Price",
      selector: (row) => (row.entryPrice !== null ? row.entryPrice : "-"),
      sortable: true,
      width: "140px",
      cell: (row) =>
        row.entryPrice !== null ? roundSmart(row.entryPrice) : "-",
    },
    {
      name: "Exit Price",
      selector: (row) => (row.exitPrice !== null ? row.exitPrice : "-"),
      sortable: true,
      width: "140px",
      cell: (row) => (row.exitPrice !== null ? roundSmart(row.exitPrice) : "-"),
    },
    {
      name: "P/L",
      selector: (row) => row?.pnl,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <span style={{ color: row.pnl < 0 ? "red" : "green" }}>
          {row.pnl !== null ? row.pnl.toFixed(2) : "-"}
        </span>
      ),
    },
    {
      name: "User Name",
      selector: (row) =>
        row.userInfo?.UserName ? row.userInfo?.UserName : "Admin",
      sortable: true,
      width: "140px",
      cell: (row) => <>{row.userInfo?.UserName}</>,
    },
    {
      name: "Details View",
      cell: (row) => (
        <Eye
          className="mx-2"
          onClick={() => {
            setRowData(row);
            setshowModal(true);
          }}
          style={{ cursor: "pointer" }}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "120px",
    },
  ];
  const handleChange = (date) => {
    // 👇 return karega format YYYY-MM-DD
    const formatted = format(date, "yyyy-MM-dd");
    return formatted;
  };
  return (
    <Content
      Page_title="Close Position"
      button_status={false}
      button_status1={true}
      show_csv_button={true}
      csv_data={ForGetCSV}
      csv_title="CLOSE POSITION"
    >
      <div className="row gx-2 gy-2 align-items-end">
        {/* From Date */}
        <div className="col-md-2 col-6">
          <label className="form-label mb-1 fw-semibold">From Date</label>
          <DatePicker
            selected={fromDate ? new Date(fromDate) : null}
            onChange={(date) => setFromDate(handleChange(date))}
            dateFormat="yyyy-MM-dd"
            placeholderText="Select date"
            className="form-control"
          />
        </div>

        {/* To Date */}
        <div className="col-md-2 col-6">
          <label className="form-label mb-1 fw-semibold">To Date</label>
          <DatePicker
            selected={toDate ? new Date(toDate) : null}
            onChange={(date) => setToDate(handleChange(date))}
            dateFormat="yyyy-MM-dd"
            placeholderText="Select date"
            className="form-control"
            minDate={fromDate ? new Date(fromDate) : null}
          />
        </div>

        {/* Strategy */}
        <div className="col-md-2 col-12">
          <label className="form-label mb-1 fw-semibold">Strategy</label>
          <select
            value={strategy}
            onChange={(e) => setStrategy(e.target.value)}
            className="form-control"
          >
            <option value="">All Strategies</option>
            {startegydata?.map((strategyOption, index) => (
              <option key={index} value={strategyOption?.strategy_name}>
                {strategyOption?.strategy_name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-3 col-12 mt-2">
          <label className="form-label mb-1 fw-semibold">Search</label>
          <input
            type="text"
            className="form-control"
            placeholder="Search by symbol or strategy"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Quantity */}
        <div className="col-md-2 col-12">
          <label className="form-label mb-1 fw-semibold">Quantity</label>
          <input
            type="number"
            className="form-control"
            value={quantity}
            onChange={(e) => {
              if (e.target.value < 0) {
                setQuantity(1);
              } else {
                setQuantity(e.target.value);
              }
            }}
          />
        </div>

        <div className="col-md-2">
          <label className="form-label mb-1">Filter by Username</label>
          <select
            className="form-control"
            value={selectedUsername}
            onChange={(e) => setSelectedUsername(e.target.value)}
          >
            <option value="">All Users</option>
            {[...new Set(
              tradeHistoryData
                .map((item) => item.userInfo?.UserName)
                .filter(Boolean)
            )].map((name, index) => (
              <option key={index} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>


        {/* Refresh Button */}
        <div className="col-md-1 col-12">
          <button
            className="btn btn-sm btn-primary ms-auto"
            onClick={() => {
              setRefresh((prev) => !prev);
              refreshbtn();
            }}
          >
            <i className="fa fa-refresh"></i>
          </button>
        </div>
      </div>

      {btnstatus === "0" && totalPnl !== undefined && (
        <div className="mt-3 d-flex justify-content-start">
          <h5>
            Realized P&L:{" "}
            <span style={{ color: Number(totalPnl) >= 0 ? "green" : "red" }}>
              {Number(roundSmart((totalPnl || 0) * (quantity || 1)))}
            </span>
          </h5>
        </div>
      )}

      {loading ? (
        <div className="mt-5 text-center">
          <Loader />
        </div>
      ) : (
        <>
          <div className="table-responsive mt-3">
            <Table
              columns={columns}
              data={filteredData}
              totalRows={totalRows}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handlePerRowsChange}
              limit={limit}
              waterMark={true}
            />
          </div>

          {btnstatus == "1" && (
            <div className="mt-3 d-flex justify-content-end">
              <h5>
                Realized P&L:{" "}
                <span style={{ color: totalPnl >= 0 ? "green" : "red" }}>
                  {Number(roundSmart(totalPnl * quantity || 1))}
                </span>
              </h5>
            </div>
          )}
        </>
      )}

      <DetailsView
        showModal={showModal}
        setshowModal={() => setshowModal(false)}
        tradeHistoryData={rowData}
      />
    </Content>
  );
};

export default Tradinghistory;
